import { LinkedIn } from "@mui/icons-material";
import { Grid, Stack, Typography, useMediaQuery, useTheme } from "@mui/material";
import { Box } from "@mui/system";
import { Link } from "../../components/Link";
import { DLBanner } from "../landing/DLBanner";
import { TEAM } from "./constants";

export default function Team() {
  const theme = useTheme();
  const md = useMediaQuery(theme.breakpoints.up("md"));
  return <Box>
  <Box width={{ xs: "90%", md: "80%" }} m="auto" py={12} maxWidth={1400}>
      <Typography variant="h6" fontWeight={500}>Team</Typography>
      <Typography variant={md ? "h1" : "h2"} fontWeight={600}>Meet the minds</Typography>
      <Box m="auto" my={8}>
        <Grid container spacing={8} columns={{ xs: 6, md: 12 }}>
          {TEAM.map(({ avatar, name, designation, linkedIn }, idx) =>
            <Grid item xs={3} md={3} key={idx}>
              <Stack key={idx} justifyContent="center" textAlign="center">
                <Link url={linkedIn} component={<Box mb={2} sx={{ "&:hover > img": { opacity: 0.6 }, "&:hover > div": { opacity: 1 }, position: "relative", "& > *": { transition: "all ease 0.3s" }, cursor: "pointer" }}>
                  <Box sx={{ position: "absolute", top: "50%", left: "50%", transform: "translate(-50%, -50%)", color: "white.main", zIndex: 9, opacity: 0 }}>
                    <LinkedIn />
                  </Box>
                  <img src={avatar} alt={`avatar-${name}`} width="100%" style={{ borderRadius: "24%", aspectRatio: "1/1", }} />
                </Box>} />
                <Typography variant="h6" fontWeight={500}>
                  {name}
                </Typography>
                <Typography variant="body1" fontWeight={500} color="text.secondary">
                  {designation}
                </Typography>
              </Stack>
            </Grid>)}
        </Grid>
      </Box>
    </Box>
    <DLBanner />
  </Box>
}